import React, {useEffect, useState} from 'react'
import './SelectBanner.css';
import Banner500 from "./Banner500";
import BannerIntroduce from "./BannerIntroduce";
import BannerProtect from "./BannerProtect";
import BannerGilt from "./BannerGilt";
import BannerStart from "./BannerStart";
import BannerSupport from "./BannerSupport";

function SelectBanner(props){
    const [BannerNumber, setBannerNumber] = useState(0);
    const [BannerSelect, setBannerSelect] = useState(['IndexBlocksSelectElementActive','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement',]);

    function FunctionBannerSelect(BannerNumber) {
        const MyBanners = ['IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement',];
        MyBanners[BannerNumber] = 'IndexBlocksSelectElementActive';
        setBannerNumber(BannerNumber);
        setBannerSelect(MyBanners);
    }

    useEffect(() => {
        let i = 0
        const intervalId = setInterval(() => {
            i = (i+1) % 5;
            const MyBanners = ['IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement','IndexBlocksSelectElement',];
            MyBanners[i] = 'IndexBlocksSelectElementActive';
            setBannerNumber(i);
            setBannerSelect(MyBanners);
        }, 5000);
        return () => clearInterval(intervalId);
    });

    return (
            <div className="IndexBlocksOutOut">
                {(BannerNumber === 0) ? <Banner500 lang={props.lang} data={props.data} PrerenderTexts={props.PrerenderTexts}/> : ''}
                {(BannerNumber === 1) ? <BannerIntroduce lang={props.lang} data={props.data} PrerenderTexts={props.PrerenderTexts}/> : ''}
                {(BannerNumber === 2) ? <BannerProtect lang={props.lang} data={props.data} PrerenderTexts={props.PrerenderTexts}/> : ''}
                {(BannerNumber === 3) ? <BannerGilt lang={props.lang} data={props.data} PrerenderTexts={props.PrerenderTexts}/> : ''}
                {(BannerNumber === 4) ? <BannerStart lang={props.lang} data={props.data} PrerenderTexts={props.PrerenderTexts}/> : ''}
                {(BannerNumber === 5) ? <BannerSupport lang={props.lang} data={props.data} PrerenderTexts={props.PrerenderTexts}/> : ''}
                <div className="IndexBlocksSelect">
                    <div className={BannerSelect[0]} role = "button" tabIndex={0} onClick={() => FunctionBannerSelect(0)}> </div>
                    <div className={BannerSelect[1]} role = "button" tabIndex={0} onClick={() => FunctionBannerSelect(1)}> </div>
                    <div className={BannerSelect[2]} role = "button" tabIndex={0} onClick={() => FunctionBannerSelect(2)}> </div>
                    <div className={BannerSelect[3]} role = "button" tabIndex={0} onClick={() => FunctionBannerSelect(3)}> </div>
                    <div className={BannerSelect[4]} role = "button" tabIndex={0} onClick={() => FunctionBannerSelect(4)}> </div>
                    <div className={BannerSelect[5]} role = "button" tabIndex={0} onClick={() => FunctionBannerSelect(5)}> </div>
                </div>
            </div>
        )}
export default SelectBanner




